<mat-form-field [style.width]="width">
  <mat-label class="font-semibold">
    {{ label | translate }}
    <small class="text-gray-400">({{ 'shared:required' | translate }})</small>
  </mat-label>
  <mat-select
    [(ngModel)]="provider"
    (ngModelChange)="valueChanged.next(provider)"
    [disabled]="disabled"
    required>
    <mat-select-trigger>
      <div class="flex items-center" *ngIf="provider">
        <div>
          <img
            class="object-cover w-6 h-6 rounded-full mr-2"
            [src]="provider.companySchool?.logo ?? DEFAULT_LOGO"
            width="36"
            height="27"
            [alt]="provider?.alias"
            loading="lazy" />
        </div>
        <div>
          <div class="font-medium">
            {{ provider?.alias }}
          </div>
          <div class="font-light">
            {{ 'country:' + provider.country.toUpperCase() | translate }}
          </div>
        </div>
      </div>
    </mat-select-trigger>
    <mat-option [value]="item" *ngFor="let item of providers">
      <div class="flex items-center">
        <div>
          <img
            class="object-cover w-6 h-6 rounded-full mr-2"
            [src]="item.companySchool?.logo ?? DEFAULT_LOGO"
            width="36"
            height="27"
            [alt]="item.iso"
            loading="lazy" />
        </div>
        <div>
          <div class="font-medium">
            {{ item?.alias }}
          </div>
          <div class="font-light">
            {{ item.accountNumber | maskAccountNumber }} |
            {{ 'country:' + item.country.toUpperCase() | translate }} |
            {{ 'currencyName:' + item.currency.toUpperCase() | translate }}
          </div>
        </div>
      </div>
    </mat-option>
  </mat-select>
</mat-form-field>
